<dsd-modal
  [id]="'modale-supprimer-' + variant"
  [buttonPrimaryLabel]="'caad.modale-supprimer-' + variant + '.primaire' | translate"
  [buttonSecondaryLabel]="'caad.modale-supprimer-' + variant + '.secondaire' | translate"
  [show]="show"
  [attr.aria-labelledby]="'modale-supprimer-' + variant"
  buttonPrimaryTheme="red"
  (dsdModalPrimaryClick)="suppressionConfirmeeClick()"
  (dsdModalSecondaryClick)="suppressionAnnuleeClick()">
  <h2 slot="title">{{ 'caad.modale-supprimer-' + variant + '.titre' | translate }}</h2>
  <p>{{ 'caad.modale-supprimer-' + variant + '.label' | translate }}</p>
</dsd-modal>
